import { render, staticRenderFns } from "./PaymentInstallments.vue?vue&type=template&id=36ae25ab&scoped=true"
import script from "./PaymentInstallments.vue?vue&type=script&lang=js"
export * from "./PaymentInstallments.vue?vue&type=script&lang=js"
import style0 from "./PaymentInstallments.vue?vue&type=style&index=0&id=36ae25ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae25ab",
  null
  
)

export default component.exports